import 'es6-promise/auto'

import * as VeeValidate from 'vee-validate'
import Vue from 'vue'
import App from './App.vue'

import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import moment from 'moment'
import registerEvents from 'serviceworker-webpack-plugin/lib/browser/registerEvents'
import runtime from 'serviceworker-webpack-plugin/lib/runtime'
import { router } from './backend'
import { userService } from './router'
import { store } from './store'
import { i18n, setLocale } from './i18n'

import { mapMutations } from 'vuex'
import './assets/css/global.css'

Vue.use(VeeValidate)
setLocale(i18n.locale, false)
if ('serviceWorker' in navigator) {
  const registration = runtime.register()
  registerEvents(registration, {})
}
Vue.mixin({
  data: function () {
    return {
      mobileFlag: false,
      userInfo: {},
      currentClubCode: '',
      courseList: [],
      clubInfoList: [],
      currentClubInfo: {
        ccode: '',
        club_name: ''
      },
      currentCourseInfo: {
        courseId: '',
        name: '',
        startIdx: 0,
        endIdx: 8
      },
      searchValue: '',
      selectCcode: '',
      selectCourseId: '',
      selectClubInfoList: [],
      alertMessage: '',
      alertCallback: null,
      tooltipActive: false
    }
  },
  created: function () {
  },
  mounted: function () {
    if (store.state.users.userInfo) {
      this.userInfo = store.state.users.userInfo
      if (this.userInfo && this.userInfo.userRole !== 'ClubManager') {
        document.querySelector('body').classList.remove('loginClub')
      }
    } else if (this.$route.path !== '/login') {
      userService.getAll().then(response => {
        this.userInfo = response.data
        store.commit('users/setUserInfo', response.data)
        if (this.userInfo && this.userInfo.userRole !== 'ClubManager') {
          document.querySelector('body').classList.remove('loginClub')
        }
      })
    }
  },

  methods: {
    ...mapMutations('clubs', { clearClubIndex: 'CLEAR_CLUB_INDEX' }),

    selectOutsideEvent: function (e) {
      let body = document.querySelector('body')
      if (!body.classList.contains('select01Active') && !body.classList.contains('select02Active') && !body.classList.contains('select03Active') && !body.classList.contains('select04Active') && !body.classList.contains('select05Active') && !this.tooltipActive && !this.tooltip1Active && !this.tooltip2Active) return
      let path = (e.composedPath && e.composedPath()) || e.path || []
      if (!path.length) {
        let node = e.target
        while (node !== document.body) {
          path.push(node)
          node = node.parentNode
        }
      }
      if (path.includes(this.$refs.select01) || path.includes(this.$refs.m_select01) || path.includes(this.$refs.select02) || path.includes(this.$refs.m_select02) || path.includes(this.$refs.select03) || path.includes(this.$refs.m_select03) || path.includes(this.$refs.select04) || path.includes(this.$refs.m_select04) || path.includes(this.$refs.select05) || path.includes(this.$refs.m_select05) || path.includes(this.$refs.tooltip) || path.includes(this.$refs.tooltip1) || path.includes(this.$refs.tooltip2)) return
      if (body.classList.contains('multiSelect')) return
      this.closeSelectAll()
    },
    moveMenu: function (path) {
      this.$router.push(path).catch(() => {})
    },
    logoutBtn: function () {
      this.clearClubIndex()
      this.$router.push('/login')
      if (!window.apl) return false
      window.apl.logout()
    },
    setClubInfo: function () {
      this.currentClubInfo = this.clubInfoList.find(it => it.ccode === this.currentClubCode)
      if (this.currentClubInfo === undefined) {
        this.currentClubInfo = {
          ccode: '',
          club_name: ''
        }
      }
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(it => ((it.startIdx <= hlidx) && (it.endIdx > hlidx)))
    },
    closeSelectAll: function () {
      document.querySelector('body.type-content').classList.remove(`select01Active`)
      document.querySelector('body.type-content').classList.remove(`select02Active`)
      document.querySelector('body.type-content').classList.remove(`select03Active`)
      document.querySelector('body.type-content').classList.remove(`select04Active`)
      document.querySelector('body.type-content').classList.remove(`select05Active`)
      document.querySelector('body.type-content').classList.remove(`multiSelect`)
      this.tooltipActive = false
    },
    openSelect01: function () {
      if (document.querySelector('body.type-content.select01Active') !== null) {
        document.querySelector('body.type-content').classList.remove(`select01Active`)
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select01Active`)
      }
    },
    openSelect02: function () {
      if (document.querySelector('body.type-content.select02Active') !== null) {
        document.querySelector('body.type-content').classList.remove(`select02Active`)
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select02Active`)
      }
    },
    openSelect03: function () {
      if (document.querySelector('body.type-content.select03Active') !== null) {
        document.querySelector('body.type-content').classList.remove(`select03Active`)
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select03Active`)
      }
    },
    openSelect04: function () {
      if (document.querySelector('body.type-content.select04Active') !== null) {
        document.querySelector('body.type-content').classList.remove(`select04Active`)
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select04Active`)
      }
    },
    openSelect05: function () {
      if (document.querySelector('body.type-content.select05Active') !== null) {
        document.querySelector('body.type-content').classList.remove(`select05Active`)
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select05Active`)
      }
    },
    openTooltip: function () {
      if (this.tooltipActive) {
        this.tooltipActive = false
      } else {
        this.closeSelectAll()
        this.tooltipActive = true
      }
    },
    changeSearchValue: function () {
      this.selectClubInfoList = this.clubInfoList.filter(it => it.club_name.includes(this.searchValue))
    },
    setDateFormat: function (date, format) {
      return moment(date).format(format)
    },
    menuToggle: function () {
      if (document.querySelector('.type-content.asideActive') == null) {
        document.querySelector('.type-content').classList.add('asideActive')
        localStorage.setItem('sideMenu', 'open')
      } else {
        document.querySelector('.type-content.asideActive').classList.remove('asideActive')
        localStorage.setItem('sideMenu', 'close')
      }
    },
    openAlert: function (message, callback) {
      document.querySelector('body.type-content').classList.add(`alertActive`)
      this.alertMessage = message
      this.alertCallback = callback
    },
    confirmAlert: function () {
      document.querySelector('body.type-content.alertActive').classList.remove(`alertActive`)
      this.moveMenu(this.alertCallback)
    },
    closeAlert: function () {
      document.querySelector('body.type-content.alertActive').classList.remove(`alertActive`)
    },
    replaceNewLine: function (str = '') {
      if (str === null) return ''
      return str.replace(/\n/g, '</br>')
    },
    ascSort: function (a, b) {
      if (a[this.sortColumn] === b[this.sortColumn]) { return 0 } return a[this.sortColumn] > b[this.sortColumn] ? 1 : -1
    },
    descSort: function (a, b) {
      if (a[this.sortColumn] === b[this.sortColumn]) { return 0 } return a[this.sortColumn] > b[this.sortColumn] ? -1 : 0
    },
    pos2Pix: function (points, lat, lon, X, Y) {
      let lats = []
      let lons = []
      lats.push(points[0])
      lats.push(points[2])
      lats.push(points[4])
      lats.push(points[6])
      lons.push(points[1])
      lons.push(points[3])
      lons.push(points[5])
      lons.push(points[7])
      let x, y
      let A, B, C, DX1, DX2, DY1, DY2
      A = lats[3] - lats[0]
      B = lons[0] - lons[3]
      C = -lons[0] * A - B * lats[0]
      DX1 = (A * lon + B * lat + C) / Math.sqrt(A * A + B * B)

      A = lats[2] - lats[1]
      B = lons[1] - lons[2]
      C = -lons[1] * A - B * lats[1]
      DX2 = (A * lon + B * lat + C) / Math.sqrt(A * A + B * B)

      A = lats[1] - lats[0]
      B = lons[0] - lons[1]
      C = -lons[0] * A - B * lats[0]
      DY1 = (A * lon + B * lat + C) / Math.sqrt(A * A + B * B)

      A = lats[2] - lats[3]
      B = lons[3] - lons[2]
      C = -lons[3] * A - B * lats[3]
      DY2 = (A * lon + B * lat + C) / Math.sqrt(A * A + B * B)

      let blnBetweenX
      blnBetweenX = (DX1 * DX2 < 0) ? 'Y' : 'N'

      if (DX1 < 0) DX1 = -DX1
      if (DX2 < 0) DX2 = -DX2

      x = Math.round(X * ((blnBetweenX === 'N' && DX1 < DX2) ? (-DX1) : DX1) / Math.sqrt((lats[1] - lats[0]) * (lats[1] - lats[0]) + (lons[1] - lons[0]) * (lons[1] - lons[0])))
      y = Math.round(Y * ((blnBetweenX === 'N' && DY1 < DY2) ? (-DY1) : DY1) / Math.sqrt((lats[3] - lats[0]) * (lats[3] - lats[0]) + (lons[3] - lons[0]) * (lons[3] - lons[0])))

      return {
        x: x,
        y: y
      }
    },
    isTodayOff: function ({
      holiday_start: start,
      holiday_end: end,
      holiday_week: week,
      holiday_week_ju: weekJu
    }) {
      if (!start || !end) return false
      const startDay = moment(start).startOf('day')
      const endDay = moment(end).endOf('day')
      const today = moment()
      if (today < startDay || today > endDay) return false
      const currentSunday = moment().add(-today.day(), 'days')
      const todayWeek = Math.ceil((currentSunday.date() + 6) / 7)
      if ((!weekJu || week < 0) || (week === today.day() && weekJu.indexOf(todayWeek.toString()) > -1)) {
        return true
      }
    },
    makeOffDayTxt: function (start, end, weekJu, week) {
      let theText = '-'
      if (start && end && weekJu && (week || week === 0)) {
        let dayName = i18n.t('common.weekdays')[week]
        if (weekJu.length > 8) {
          theText = i18n.t('common.everyWeek', { day: dayName })
        } else if (weekJu.length > 0) {
          theText = i18n.t('common.everyMonth', { week: weekJu, day: dayName })
        }
      } else if (start && end) {
        let startDay = moment(start).format('YY-MM-DD')
        let endDay = moment(end).format('YY-MM-DD')
        theText = startDay + ' ~ ' + endDay
      }
      return theText
    },
    confirmPinSize: function (sizeNum) {
      if (!sizeNum) return '-'
      let pinSizeArr = [
        {size: '13', code: '0'},
        {size: '20', code: '1'},
        {size: '27', code: '2'}
      ]
      if (Number(sizeNum) > -1 && Number(sizeNum) < 3) {
        let pinSize = pinSizeArr.find(it => it.code === sizeNum).size
        return pinSize
      } else {
        return '-'
      }
    },
    setRegionCode: function (cCode, rCode) {
      // 82031 경기도
      // 82033 강원도
      // 82041 충청도
      // 82055 경상도
      // 82061 전라도
      // 82064 제주도
      if (!cCode) return ''
      if (!rCode) {
        let code = cCode.substr(0, 5)
        if (code === '82031') {
          return 1
        } else if (code === '82033') {
          return 40
        } else if (code === '82041') {
          return 10
        } else if (code === '82055') {
          return 30
        } else if (code === '82061') {
          return 20
        } else if (code === '82064') {
          return 50
        }
      } else {
        return rCode
      }
    },
    calcPercentage: function (data, sum) {
      if (!sum) {
        return '100%'
      } else if (!data) {
        return '0%'
      }
      return Math.floor(data / sum * 100) + '%'
    },
    isHyphen: function (value) {
      if (!value) {
        return '-'
      } else {
        return value
      }
    }
  },
  filters: {
    formatDateTime (UTCtime) {
      if (!UTCtime) return ''
      return moment(UTCtime).format('YYYY-MM-DD HH:mm:ss')
    }
  }
})

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    ChartJsPluginDataLabels
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js